import { compose } from 'recompose';
import { connect } from 'react-redux';
import { selectors as shipmentSelectors } from 'state/shipments';

import StopAddressWhenEdit from 'components/form/StopAddressWhenEdit/component';

const enhance = compose(
  connect(
    (state, { stopType, shipmentKey }) => ({
      rawAddress: shipmentSelectors.getShipmentRawAddress(
        state,
        shipmentKey,
        stopType
      ),
    }),
    {}
  )
);

export default enhance(StopAddressWhenEdit);
